import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as AnalysisState from './modules/analysis/_store';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
    const newRelicSnippet = window.document.createElement('script');
    newRelicSnippet.src = '../assets/js/nr.min.js';
    window.document.body.appendChild(newRelicSnippet);
  }

}
